import { deprecatedGenerateEventsDefinition, generateEventsFromEnum } from '@guiker/event'

import { Building } from '../../entity'
import { baseEvent } from '../base'

const baseBuildingEvent = {
  ...baseEvent,
  entity: 'BUILDING',
  data: null as unknown as Building,
}

export enum BuildingEventTypes {
  ADDRESS_UPDATED = 'ADDRESS_UPDATED',
  BUILDING_DETAIL_UPDATED = 'BUILDING_DETAIL_UPDATED',
  CREATION_INITIATED = 'CREATION_INITIATED',
  CREATION_COMPLETED = 'CREATION_COMPLETED',
}

export const BuildingEventsDefinition = deprecatedGenerateEventsDefinition({
  ...baseBuildingEvent,
  eventTypes: BuildingEventTypes,
})

export const BuildingEvents = generateEventsFromEnum(baseBuildingEvent)(BuildingEventTypes)
